var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"status-label",style:({ backgroundColor: _vm.stateColor.backgroundColor, color: _vm.stateColor.fontColor })},[_vm._v(_vm._s(_vm.stateText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }